import React, { Component } from 'react'
import { Box, CustomizedErrorMessage } from '../../styles.style'
import { ErrorMessage, getIn } from 'formik'
import { ClientService } from '../../../../services/client.service'

class DocumentRG extends Component {
	constructor(props) {
		super(props)
		this.state = {
			rg: ''
		}
	}

	nextPage = () => {
		this.props.handleSetRg(this.props.values.rg)
		this.props.nextStep()
	}

	setRg = e => {
		const { providerSignupData } = this.props
		const rg = e.target.value;
		this.setState({ rg })

		var errorMessage = ''
		if (!rg) {
			errorMessage = 'Informe o RG'
		}
		this.setState({ rg: rg, rgError: errorMessage })
		if (errorMessage)
			return;

		var obj = { rg, email: providerSignupData.email }
		ClientService.checkExistingRGDocument(obj).then(data => {
			if (data.success) {
				if (data.data)
					this.setState({ rg: rg, rgError: 'Já existe um usuário cadastrado com o RG informado' })
			}
		})
	}

	render() {
		const {
			handleBlur,
			handleChange,
			values,
			errors,
			touched,
			prevStep,
			setFieldValue
		} = this.props
		const { rgError } = this.state

		return (
			<Box>
				<div className="field">
					<header>
						<h5>Ok, precisamos do seu RG</h5>
					</header>

					<div>
						<input
							className={
								getIn(errors, 'rg') &&
									getIn(touched, 'rg')
									? 'field-error input-big'
									: 'input-big'
							}
							type="text"
							placeholder="RG"
							id="rg"
							name="rg"
							maxLength={14}
							value={this.state.rg || values.rg}
							onChange={e => {
								this.setRg(e)
								handleChange(e)
								setFieldValue('rg', e.target.value)
							}}
							onBlur={handleBlur}
						/>
						{rgError && (
							<CustomizedErrorMessage>
								{rgError}
							</CustomizedErrorMessage>
						)}
					</div>
				</div>


				<footer className="footer">
					<button
						className="button transparent"
						type="button"
						onClick={() => prevStep()}>
						Voltar
					</button>
					<button
						disabled={
							!values.rg ||
							this.state.rgError ||
							values.rg.length == 0 ||
							(errors.rg && touched.rg)
						}
						className={
							errors.rg && touched.rg || this.state.rgError
								? 'disabled button'
								: 'button'
						}
						type="button"
						onClick={() => this.nextPage()}>
						Próximo
					</button>
				</footer>
			</Box>
		)
	}
}

export default DocumentRG
